import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clientService from '../../api/clientService';
import { useNotifications } from '../../context/NotificationContext';
import LoadingSpinner from '../common/LoadingSpinner';
import BookingCard from '../common/BookingCard';
import EmptyState from '../common/EmptyState';

export default function ClientDashboard() {
  const { t } = useTranslation();
  const notify = useNotifications();
  const [data, setData] = useState(null);

  useEffect(() => {
    clientService.getDashboard().then(setData).catch((e) => notify.apiError(e));
  }, [notify]);

  if (!data) return <div className="page"><div className="container"><LoadingSpinner /></div></div>;

  const stats = [
    [t('client.totalBookings'), data.totalBookings],
    [t('client.active'), data.activeBookings],
    [t('client.completed'), data.completedBookings],
    [t('client.reviewsWritten'), data.reviewsWritten],
  ];

  return (
    <div className="page">
      <div className="container stack" style={{ gap: '1.5rem' }}>
        <div className="page-head">
          <div>
            <h1>{t('client.hi', { name: data.profile.firstName })}</h1>
            <p>{data.profile.city || ''}</p>
          </div>
          <Link to="/technicians" className="btn accent">{t('client.bookTechnician')}</Link>
        </div>

        <div className="grid stats">
          {stats.map(([l, n]) => (
            <div key={l} className="stat"><div className="n">{n}</div><div className="l">{l}</div></div>
          ))}
        </div>

        <div>
          <div className="spread" style={{ marginBottom: '.75rem' }}>
            <h2>{t('client.recentBookings')}</h2>
            <Link to="/client/bookings">{t('common.all')}</Link>
          </div>
          {data.recentBookings?.length ? (
            <div className="stack">
              {data.recentBookings.map((b) => (
                <BookingCard key={b.id} booking={b} perspective="client" />
              ))}
            </div>
          ) : (
            <EmptyState icon="calendar-plus" title={t('client.noBookings')}>
              <Link to="/technicians">{t('technician.browseTitle')}</Link>
            </EmptyState>
          )}
        </div>
      </div>
    </div>
  );
}
